import { MOCK_REVISION_API, expected } from '@aloft/toolkit-shared';

import { useCreateMockRevisionOrderAPI } from '../../../../../hooks/api/toolkitComponents.ts';

export const useCreateMockRevisionOrder = (): ((originalOrderId: string) => Promise<string>) => {
  const mutation = useCreateMockRevisionOrderAPI();

  return async (originalOrderId) => {
    const body = MOCK_REVISION_API.POST.REQUEST.BODY.parse({ originalOrderId });
    const res = await mutation.mutateAsync({ body });
    const parsed = MOCK_REVISION_API.POST.RESPONSE.parse(res);
    return expected(parsed.id);
  };
};
